import { Component } from '@angular/core';
import { NavParams, AlertController, ToastController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';

@Component({
  selector: 'event-embed',
  templateUrl: 'event-embed.html'
})
export class EventEmbedComponent {

  obsEmbed: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataEmbed: any = false;

  constructor(public eventProvider: EventData, public params: NavParams, public alertCtrl: AlertController, public toastCtrl: ToastController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'embed').subscribe(stateModule => {
      this.closeListener(true);

      if (stateModule.$value === true) {
        this.obsEmbed = this.eventProvider.getEmbed(this.client, this.event.id).subscribe((data) => {
          this.dataEmbed = data;

          this.componentState = true;
        });
      } else {
        this.dataEmbed = false;
        this.componentState = false;
        console.log("Módulo Embed deshabilitado");
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  closeListener(primaryListener = false) {
    if (this.obsListener && !primaryListener) {
      console.log('Se eliminan los observables de Embed');
      this.obsListener.unsubscribe();
    }
    if (this.obsEmbed) {
      this.obsEmbed.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}



// WEBPACK FOOTER //
// ./src/components/event-embed/event-embed.ts